module.exports = __webpack_public_path__ + "static/img/video-tutorial.a28ab4a0.svg";